import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Boxing = () => {
  return (
    <SportsLayoutComp name={'Boxing'}/> 
  )
}

export default Boxing